import { CALENDAR } from "../config";
import { get } from "./apiHelper";

const buildQuery = (params = {}) => {
  const q = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
  return q ? `?${q}` : "";
};

export const fetchCalendar = (params = {}) =>
  get(`${CALENDAR}${buildQuery(params)}`, { noCache: true });
